import { Axios } from "api/axios"; // <-- your custom Axios instance
import CancelBackButton from "components/Buttons/CancelBackButton";
import SubmitButton from "components/Buttons/SubmitButton";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AddUserTypeModal = ({ show, handleClose, onSuccess, editData }: any) => {
  const [formData, setFormData] = useState({ user_type: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const user_type_id = editData?.user_type_id ?? null;
  const isEdit = user_type_id !== null;

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const isValid = /^[A-Za-z\s]*$/.test(value);
    if (isValid) {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    if (show) {
      if (isEdit && editData?.user_type) {
        setFormData({ user_type: editData.user_type });
      } else {
        setFormData({ user_type: "" });
      }
    }
  }, [show, isEdit, editData]);

  const handleModalClose = () => {
    setFormData({ user_type: "" });
    handleClose();
  };

  const handleSubmit = async () => {
    if (!formData.user_type.trim()) {
      toast.error("User Type is required");
      return;
    }

    if (!/^[A-Za-z\s]+$/.test(formData.user_type)) {
      toast.error("User Type must contain only letters and spaces");
      return;
    }

    try {
      setLoading(true);
      let response = null;

      if (isEdit) {
        response = await Axios.put(
          `/user-types/${user_type_id}/update/`,
          formData
        );
      } else {
        response = await Axios.post("/user-types/create/", formData);
      }

      if (response?.status === 200 || response?.status === 201) {
        toast.success(
          `User Type ${isEdit ? "Updated" : "Created"} Successfully`
        );
        handleModalClose();
        if (onSuccess) {
          onSuccess();
        }
        // setTimeout(() => {
          // navigate("/user-type");
          // window?.location?.reload();
        // }, 2000);
      }
    } catch (error: any) {
      // Handle different error response structures
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.response?.data?.error?.user_type?.[0] ||
        error?.message ||
        "Failed to add User Type";
      
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleModalClose}
      centered
      contentClassName="custom-modal"
    >
      <Modal.Header className="border-0">
        <Modal.Title className="fw-bold">
          {isEdit ? "Edit" : "Add"} User Type
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleModalClose}
        ></button>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="userType" className="form-label fw-medium">
            User Type
          </label>
          <input
            type="text"
            className="form-control custom-input"
            id="userType"
            name="user_type"
            placeholder="Enter User Type"
            value={formData?.user_type}
            onChange={handleChange}
          />
        </div>
        <div className="d-flex justify-content-center gap-3 mt-4">
            <CancelBackButton
              // to="/user-type-list"
              onClick={handleModalClose}
            />

          <SubmitButton isSubmitting={loading} labels={{
            create: "Add User Type",
            update: "Update User Type",
            submitting: "Adding...",
            updating: "Updating...",
          }} onClick={handleSubmit} isEdit={isEdit}/>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddUserTypeModal;
